module.exports = __webpack_public_path__ + "media/images/icon_list/pin_filled-301c008a07e53e591b36e43fcdf0e6f2.svg";